/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * System process and reason that automatically resolved an assistance.
 */
export type EmployeeAssistanceSystemResolutionActor = {
    type: EmployeeAssistanceSystemResolutionActor.type;
    reason: EmployeeAssistanceSystemResolutionActor.reason;
};
export namespace EmployeeAssistanceSystemResolutionActor {
    export enum type {
        SYSTEM = 'system',
    }
    export enum reason {
        SUPERSEDED = 'superseded',
        CONVERSATION_RECOVERED = 'conversation-recovered',
        EXPLICIT_RECOVERY = 'explicit-recovery',
    }
}

